import { render, staticRenderFns } from "./feedback_config_panel.vue?vue&type=template&id=5e07305f&scoped=true&"
import script from "./feedback_config_panel.vue?vue&type=script&lang=ts&"
export * from "./feedback_config_panel.vue?vue&type=script&lang=ts&"
import style0 from "./feedback_config_panel.vue?vue&type=style&index=0&id=5e07305f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e07305f",
  null
  
)

export default component.exports